<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getSaleApproveTableRecord"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">{{COMPENSATION_AFTER_SALE}}</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['D'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCompesationCreate">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMyCompensationList" />
                </Col>
            </Row>
        </Card>

        <Modal v-model="compenstationModal.show"
            :title="COMPENSATION_AFTER_SALE"
            class-name="vertical-center-modal"
            width="60">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Form label-position="top">
                <Row :gutter="16">
                    <Col span="8">
                    <FormItem label="配送单号">
                        <Input v-model="deliveryCode"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label=" ">
                        <Button type="info"
                            @click="onSearchDelvieryInfo">查询</Button>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <Row :gutter="16">
                <Col span="24">
                <Table size="small"
                    :columns="productTable.columns"
                    :data="productTable.data"
                    :loading="productTable.loading"
                    highlight-row
                    stripe
                    border />
                </Col>
            </Row>
            <div slot="footer">
                <Button type="primary"
                    @click="onCompensationSave">确认</Button>
                <Button type="error"
                    @click="compenstationModal.show=false">取消</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import {
    getCompensationList,
    saveCompensation
} from "@/api/modules/sale-management/sale-approve";
import { getDistributionStationDeliveryList } from "@/api/modules/distributionStation-management/distributionStation-delivery";
import { arrayUnique } from "@/libs/logic";
import { COMPENSATION_AFTER_SALE } from './compensation-type';
export default {
    name: "StationCompensationList",
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            COMPENSATION_AFTER_SALE,
            innerSpin: false,
            mainTable: {
                columns: [
                    { title: "退款单号", key: "compensationRecordCode", width: 180, align: "center" },
                    { title: "关联配送单号", key: "compensationRecordRelateRecordCode", width: 180, align: "center" },
                    { title: "退款方", key: "compensationRecordPayerName", align: "center" },
                    { title: "被退款方", key: "compensationRecordPayeeName", align: "center" },
                    { title: "退款金额", key: "compensationRecordTotalValue", align: "center" },
                    { title: "经办", key: "compensationRecordOperatorName", align: "center" },
                    {
                        title: "创建时间",
                        key: "compensationRecordCreatedAt",
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.compensationRecordCreatedAt)
                    },
                    {
                        title: '操作',
                        key: 'withDrawAction',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onShowCompensation(params.row);
                                        }
                                    }
                                }, '查看')]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: "退款单号", type: "Input", value: "", name: "compensationRecordCode", sql: "like" },
                    { label: "关联单号", type: "Input", value: "", name: "compensationRecordRelateRecordCode", sql: "like" },
                    { label: "退款方", type: "Input", value: "", name: "compensationRecordPayerName", sql: "like" },
                    { label: "被退款方", type: "Input", value: "", name: "compensationRecordPayeeName", sql: "like" },
                    { label: "经办", type: "Input", value: "", name: "compensationRecordOperatorName", sql: "like" }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            productTable: {
                columns: [
                    { title: "客户", key: "userPersonName", align: "center" },
                    { title: "编号", key: "productCode", align: "center" },
                    { title: "品名", key: "productName", align: "center" },
                    { title: "配送数量", key: "distributionStationDeliveryQuantity", align: "center" },
                    { title: "收到数量", key: "distributionStationDeliveryDetailComplainRecevieCount", align: "center" },
                    { title: "问题数量", key: "distributionStationDeliveryDetailComplainQualityCount", align: "center" },
                    // { title: "定单价格", key: "preSaleOrderDetailProductDisplayPrice", align: "center" },
                    // { title: "定单数量", key: "preSaleOrderDetailOrderQuantity", align: "center" },
                    {
                        title: "退款价格", key: "compensationDetailProductPrice", align: "center",
                        render: (h, params) => {
                            return h(DecimalInput, {
                                props: {
                                    value: params.row.compensationDetailProductPrice,
                                    max: 1000000
                                },
                                on: {
                                    change: newVal => {
                                        this.productTable.data[params.index].compensationDetailProductPrice = newVal;
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: "退款数量", key: "compensationDetailProductCount", align: "center",
                        render: (h, params) => {
                            return h(IntegerInput, {
                                props: {
                                    value: params.row.compensationDetailProductCount,
                                    max: 1000000
                                },
                                on: {
                                    change: newVal => {
                                        this.productTable.data[params.index].compensationDetailProductCount = newVal;
                                    }
                                }
                            });
                        }
                    }],
                data: [],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            deliveryCode: '',
            compenstationModal: {
                show: false,
                compensationRecordUuid: '',
                compensationRecordCode: '',
                compensationRecordRelateRecordUuid: '',
                compensationRecordType: '',
                details: []
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMyCompensationList();
            const query = this.$route.query;
            if (query.deliveryCode) {
                this.deliveryCode = query.deliveryCode;
                this.onSearchDelvieryInfo();
                this.onCompesationCreate();
            }
        },
        arrayUnique,
        onSearchDelvieryInfo() {
            let tempsearch = search.getSearchParams();
            search.globalRemoveFilterConditionKey(tempsearch, 'distributionStationDeliveryRecordCode');
            tempsearch.filters.enable = true;
            tempsearch.filters.conditions.push({
                name: 'distributionStationDeliveryRecordCode',
                type: 'eq',
                value: this.deliveryCode
            });
            this.productTable.loading = true;
            getDistributionStationDeliveryList(tempsearch).then(res => {
                this.productTable.loading = false;
                if (res.code === 0) {
                    if (res.data.records.length === 0) {
                        this.productTable.data = [];
                        this.$Modal.error({ title: '未找到配送单记录', content: '' });
                        return;
                    }
                    else {
                        this.productTable.data = res.data.records;
                        this.productTable.data.forEach(p => {
                            let detail = this.compenstationModal.details.find(d => {
                                return d.compensationDetailRelateDetailUuid === p.distributionStationDeliveryDetailUuid;
                            });
                            if (detail) {
                                p.compensationDetailProductPrice = detail.compensationDetailProductPrice;
                                p.compensationDetailProductCount = detail.compensationDetailProductCount;
                            }
                            else {
                                p.compensationDetailProductPrice = 0;
                                p.compensationDetailProductCount = 0;
                            }
                        });
                        this.compenstationModal.compensationRecordRelateRecordUuid = this.productTable.data[0].distributionStationDeliveryRecordUuid;
                    }
                }
            });
        },
        onCompesationCreate() {
            this.compenstationModal.compensationRecordUuid = '';
            this.compenstationModal.compensationRecordCode = '';
            this.compenstationModal.compensationRecordRelateRecordUuid = '';
            this.compenstationModal.details = [];
            this.productTable.data = [];
            this.compenstationModal.show = true;
        },
        onShowCompensation(row) {
            this.compenstationModal.compensationRecordUuid = row.compensationRecordUuid;
            this.compenstationModal.compensationRecordCode = row.compensationRecordCode;
            this.compenstationModal.compensationRecordRelateRecordUuid = row.compensationRecordRelateRecordUuid;
            this.compenstationModal.details = row.compensationDetailModels;
            this.deliveryCode = row.compensationRecordRelateRecordCode;

            this.onSearchDelvieryInfo();
            this.compenstationModal.show = true;
        },
        onCompensationSave() {
            let productList = this.productTable.data.filter(p => {
                return p.compensationDetailProductCount > 0;
            });
            if (productList.length === 0) {
                this.$Modal.error({ title: '必须填写商品退款数量', content: '' });
                return;
            }
            if (productList.find(e => {
                return e.compensationDetailProductPrice < 0;
            })) {
                this.$Modal.error({ title: '填写的商品退款金额不能少于0', content: '' });
                return;
            }

            let data = {
                compensationRecordUuid: this.compenstationModal.compensationRecordUuid,
                compensationRecordRelateRecordUuid: this.compenstationModal.compensationRecordRelateRecordUuid,
                compensationRecordType: COMPENSATION_AFTER_SALE,
                details: productList.map(e => {
                    return {
                        compensationDetailRelateDetailUuid: e.distributionStationDeliveryDetailUuid,
                        compensationDetailProductUuid: e.productUuid,
                        compensationDetailProductPrice: e.compensationDetailProductPrice,
                        compensationDetailProductCount: e.compensationDetailProductCount
                    };
                })
            };
            this.innerSpin = true;
            saveCompensation(data).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.compenstationModal.show = false;
                            this.init();
                        }
                    });
                }
            });
        },
        getMyCompensationList(reset = false) {
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "compensationRecordType");
            this.mainTable.tableSearch.filters.enable = true;
            this.mainTable.tableSearch.filters.conditions.push({
                name: 'compensationRecordType',
                type: 'eq',
                value: COMPENSATION_AFTER_SALE
            });

            getCompensationList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(
                        this.mainTable.tableSearch,
                        res.data.filterRecordCount
                    );
                }
            });
        }
    }
};
</script>

<style scoped></style>
